import { Divider } from "antd"
import { isFunction } from "lodash"

const SectionToYearCard = ({ className = '', section, style = {}, onClick }) => {
  const handleClick = () => {
    if (isFunction(onClick)) {
      onClick(section)
    }
  }

  return (
    <div
      className={`${className} pd-4 bdr-rds-4 tx-alg-ctr fake-gray-button not-selectable-text`}
      style={style}
      onClick={handleClick}
    >
      <span className='ft-l'> {section.school.name} <br /> </span>

      <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

      <span className='ft-reg pd-4'>
        {`${section?.sectionToYear.sectionAbbreviation} ─ ${section?.sectionToYear.schoolYearName}`}
      </span>
    </div>
  )
}

export default SectionToYearCard